import StickerAvatar from "../../../common/components/functional/icons/StickerAvatar";
import CoreLogo from "../../../common/components/functional/eezy/CoreLogo";
import { ListItemAvatar } from "@mui/material";
import React from "react";
import { Participant } from "../types/queries";

type Props = {
  hasMultipleParticipants: boolean;
  singleOtherParticipant?: Participant | null;
  supportMessageSenderParticipant?: Participant | null;
  isSystemMessageType: boolean;
  isTalentConversation: boolean;
};

const InboxRowAvatar = ({
  hasMultipleParticipants,
  singleOtherParticipant,
  supportMessageSenderParticipant,
  isSystemMessageType,
  isTalentConversation,
}: Props) => {
  const getStickerColor = () => {
    if (isSystemMessageType) {
      // TODO: should this be added to the theme?
      //  darker than primary.dark, copied from eezy logo
      return "#351F65";
    }

    return isTalentConversation ? "success.main" : "primary.light";
  };

  const name = hasMultipleParticipants
    ? `${supportMessageSenderParticipant?.firstName} ${supportMessageSenderParticipant?.lastName}`
    : `${singleOtherParticipant?.firstName} ${singleOtherParticipant?.lastName}`;

  return (
    <ListItemAvatar>
      <StickerAvatar
        name={name}
        stickerSx={{
          color: getStickerColor(),
        }}
        {...(isSystemMessageType && {
          image: <CoreLogo width="40px" height="40px" />,
        })}
      />
    </ListItemAvatar>
  );
};

export default InboxRowAvatar;
